import { Controller } from '@hotwired/stimulus'

export default class extends Controller<HTMLElement> {
  static targets = ['plannedPickup', 'plannedDelivery', 'actualPickup', 'actualDelivery']

  declare readonly plannedPickupTargets: HTMLInputElement[]
  declare readonly plannedDeliveryTargets: HTMLInputElement[]
  declare readonly actualPickupTargets: HTMLInputElement[]
  declare readonly actualDeliveryTargets: HTMLInputElement[]

  copyPlannedDate(e: MouseEvent): void {
    const key = (e.currentTarget as HTMLButtonElement)?.dataset?.key as 'Pickup' | 'Delivery'
    const plannedTargets = this[`planned${key}Targets`]
    const actualTargets = this[`actual${key}Targets`]
    plannedTargets.forEach((source, index) => {
      actualTargets[index].value = source.value
    })
  }
}
